import React from 'react';

export const useStudentAccess = (email: string) => {
    const admins = [
        '',
    ];

    return admins.some(item => item === email);
};
